import { getManeuverInfo, getManeuverColor } from '../lib/maneuvers';
import { cn } from '@/lib/utils';

interface ManeuverIconProps {
  type: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZES = {
  sm: 'w-6 h-6',
  md: 'w-10 h-10',
  lg: 'w-14 h-14',
};

const ICON_SIZES = {
  sm: 16,
  md: 24,
  lg: 32,
};

export function ManeuverIcon({ type, size = 'md', className }: ManeuverIconProps) {
  const { icon: Icon } = getManeuverInfo(type);
  const color = getManeuverColor(type);

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full bg-white shadow-md',
        SIZES[size],
        className
      )}
      style={{ backgroundColor: color }}
    >
      <Icon size={ICON_SIZES[size]} className="text-white" strokeWidth={2.5} />
    </div>
  );
}
